import { spApi } from './sp';

export const saveGooglePlaceIdApi = spApi.injectEndpoints({
  endpoints: (builder) => ({

    saveGooglePlaceId: builder.mutation({
      query: ({ businessId, googlePlaceId }) => ({
        url:    `/business/${businessId}/google-place-id`,
        method: 'POST',
        body:   { googlePlaceId }
      }),
      invalidatesTags: ['businessDetails']
    }),

  }),
  overrideExisting: false,
});

export const { useSaveGooglePlaceIdMutation } = saveGooglePlaceIdApi;